// src/hooks/useFileHandler.js
import { useState, useEffect } from 'react';
import { ACCEPTED_IMAGE_MIME_TYPES } from '../constants';

export const useFileHandler = (setAppMessage) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imageUrls, setImageUrls] = useState({});

  useEffect(() => {
    // Cleanup object URLs on unmount
    return () => { Object.values(imageUrls).forEach(URL.revokeObjectURL); };
  }, [imageUrls]);

  const handleFileUpload = (files) => {
    if (!files || files.length === 0) return;

    const validFiles = files.filter(file => ACCEPTED_IMAGE_MIME_TYPES.includes(file.type));
    const invalidFileCount = files.length - validFiles.length;

    if (invalidFileCount > 0) {
      setAppMessage({ text: `${invalidFileCount} file(s) were rejected. Only JPG, PNG, GIF, and WebP are accepted.`, severity: 'warning' });
    }

    if (validFiles.length > 0) {
      const newFiles = [...selectedFiles, ...validFiles];
      setSelectedFiles(newFiles);
      
      const newImageUrls = { ...imageUrls };
      validFiles.forEach(file => { newImageUrls[file.name] = URL.createObjectURL(file); });
      setImageUrls(newImageUrls);
      
      if (invalidFileCount === 0) {
        setAppMessage({ text: `${validFiles.length} file(s) added. Total: ${newFiles.length}. Ready to process.`, severity: 'info' });
      }
    }
  };

  const handleRemoveImage = (filenameToRemove) => {
    setSelectedFiles(prev => prev.filter(file => file.name !== filenameToRemove));
    setImageUrls(prev => {
      const newUrls = { ...prev };
      delete newUrls[filenameToRemove];
      return newUrls;
    });
  };

  const resetFiles = () => {
    setSelectedFiles([]);
    setImageUrls({});
  };

  return {
    selectedFiles,
    imageUrls,
    handleFileUpload,
    handleRemoveImage,
    resetFiles
  };
};